import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherDataAttachmentList } from '../../../../item/ItemResume';
import { AttachmentItems } from '../../Res/AttachmentItems';

export const OtherData_attachment = "attachment"
export function ContractorAttendanceRegisterAttachment({ attachment, save, isEdit }) {
    const [mAttachment, setmAttachment] = useState({})
    const [mAttachmentList, setAttachmentList] = useState([])

    var parameterArray = [
        { key: "attachment", name: "附件-小於10Mb", br: false, editInfo: false },
    ]

    useEffect(() => {
        //console.log(attachment)
        if (attachment !== undefined && attachment !== mAttachment && Object.keys(attachment).length !== 0) {
            setmAttachment(attachment)
            var mRespResumeOtherDataAttachmentList = new RespResumeOtherDataAttachmentList({})
            mRespResumeOtherDataAttachmentList.fromJson(attachment.resumeData, parameterArray)
            mRespResumeOtherDataAttachmentList.attachmentList.attachment = attachment
            console.log(mRespResumeOtherDataAttachmentList)
            setAttachmentList(mRespResumeOtherDataAttachmentList.attachmentList)
        }
    }, [attachment])


    function setAttachment(key, attachment) {
        //console.log(key)
        //console.log(attachment)
        //console.log(mAttachmentList)
        mAttachmentList[key] = attachment
        setAttachmentList(attachment)
    }

    async function saveOtherDataAttachment() {
        save(mAttachmentList)
    }



    var title = "廠商提供資料"
    var content =
        <>
            {
                parameterArray.map((f, i) => (
                    <AttachmentItems key={"pm" + i} index={f.key} parameter={f} attachment={mAttachmentList[f.key]} setAttachment={setAttachment} isEdit={isEdit} uploadAll={true} />
                ))
            }
            {isEdit ?
                <>
                    {/* <div class="hr-line-dashed"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-2">
                                <p>支援的檔案格式</p>
                            </div>
                            <div class="col-md-10">
                                <strong>文件：&nbsp;.pdf&nbsp;&nbsp;.doc&nbsp;&nbsp;.docx&nbsp;&nbsp;；&nbsp;&nbsp;圖片：&nbsp;.jpg&nbsp;&nbsp;.jpeg&nbsp;&nbsp;.png；&nbsp;&nbsp;檔案大小&lt; 5MB   </strong>
                            </div>
                        </div>
                    </div> */}
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <span style={{ lineHeight: "35px" }}>請注意！未按下儲存，檔案不會改變---></span>
                            <SubmitButton name={"儲存"} action={saveOtherDataAttachment} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={true} />
        </>
    )
}
